// ---
import React from "react";
import {connect} from "react-redux";
import {modal, AbstractReactComponent, DetailValue, Icon} from "mc/lib";
import {CardBlock, Row, Col, Button} from "reactstrap";
import {formatDate, localUTCToDate, formatCurrency} from "mc/lib/utils/commons";
import PridaniVyrovnaniForm from '../forms/PridaniVyrovnaniForm';
import * as subjektFormatter from "mc/lib/utils/subjektFormatter";
import ParovaniPlatebApi from '../api/gen/pohledavky/ParovaniPlatebApi';
import * as parovaniActions from "../actions/ParovaniActions";

import "./ParovaniPlatebRow.scss";

/**
 * Řádek zobrazující detail platby na přehledu párování plateb.
 */
class ParovaniPlatebRow extends AbstractReactComponent {

    static propTypes = {
        kodTypPripad: React.PropTypes.string,
        platba: React.PropTypes.object.isRequired,
    };

    state = {
        zobrazVyrovnani: false
    };

    handleVyrovnat = (zbyva) => {
        const {kodTypPripad, platba, dispatch} = this.props;
        dispatch(modal.ModalActions.show(PridaniVyrovnaniForm, {
            onSubmit: (data) => {
                const {pripad} = data;
                return ParovaniPlatebApi.vyrovnatPlatbu(pripad.id, platba.hlavickaPlatba.id, parseInt(data.castka))
                    .then(() => {
                        dispatch(modal.ModalActions.hide());
                        dispatch(parovaniActions.invalidatePlatby());
                    });
            },
            kodTypPripad: kodTypPripad,
            zbyva: zbyva,
        }, "Přidání vyrovnání"));
    };

    handleZobrazVyrovnani = () => {
        const {zobrazVyrovnani} = this.state;
        this.setState({zobrazVyrovnani: !zobrazVyrovnani});
    };

    handleZrusitVyrovnani = (vyrovnani) => {
        ParovaniPlatebApi.zrusitVyrovnaniPripadu(vyrovnani.hlavickaPlatbaId, vyrovnani.id).then(() => {
            this.props.dispatch(parovaniActions.invalidatePlatby())
        });
    };

    calcVyrovnano = (vyrovnaniList) => {
        let vyrovnano = 0;
        vyrovnaniList && vyrovnaniList.forEach(row => (vyrovnano += row.castkaSumyVyrovnani));
        return vyrovnano;
    };

    render() {
        const {platba} = this.props;
        const {zobrazVyrovnani} = this.state;

        const hlavickaPlatba = platba.hlavickaPlatba;
        const vyrovnano = this.calcVyrovnano(platba.vyrovnani);
        const zbyva = hlavickaPlatba.castka - vyrovnano;

        return <CardBlock>
            <Row>
                <Col xs={12} className="items-list-row-header">{hlavickaPlatba.cisloUctu}</Col>
            </Row>
            <Row>
                <Col xs={6} sm={4} md={2}><DetailValue label="Datum platby">{formatDate(localUTCToDate(hlavickaPlatba.datumPlatby))}</DetailValue></Col>
                <Col xs={6} sm={4} md={2}><DetailValue label="Specifický symbol">{hlavickaPlatba.ss}</DetailValue></Col>
                <Col xs={6} sm={4} md={2}><DetailValue label="Variabilní symbol">{hlavickaPlatba.vs}</DetailValue></Col>
                {/*<Col xs={6} sm={3} md={2}><DetailValue label="Na účet"></DetailValue></Col>*/}
                <Col xs={12} md={6}><DetailValue label="Poznámka">{hlavickaPlatba.poznamka}</DetailValue></Col>
            </Row>
            <Row>
                <Col xs={6} sm={4} md={2}><DetailValue label="Částka">{formatCurrency(hlavickaPlatba.castka)}</DetailValue></Col>
                <Col xs={6} sm={4} md={2}><DetailValue label="Vyrovnáno">{formatCurrency(vyrovnano)}</DetailValue></Col>
                <Col xs={6} sm={4} md={2}>
                    <DetailValue className="dl-with-btn" label="Zbývá">{formatCurrency(zbyva)}</DetailValue>
                    {zbyva !== 0 && <Button type="button" onClick={() => this.handleVyrovnat(zbyva)}>Vyrovnat</Button>}
                </Col>
                {platba.vyrovnani && platba.vyrovnani.length > 0 && <Col xs={12} md={6} className="col-divider">
                    <div className="divider"/>
                    <Button className="btn-link" type="button" onClick={this.handleZobrazVyrovnani}>
                        {zobrazVyrovnani ? <Icon icon="angle-up"/> : <Icon icon="angle-down"/>}
                        {zobrazVyrovnani ? ' Skrýt detaily vyrovnání' : ' Zobrazit detaily vyrovnání'}
                    </Button>
                </Col>}
            </Row>
            {zobrazVyrovnani && platba.vyrovnani.map(v => {
                return <Row>
                    <Col xs={12} sm={4} md={2}/>
                    <Col xs={12} sm={4} md={2}>{formatCurrency(v.castkaSumyVyrovnani)}</Col>
                    <Col xs={12} sm={4} md={2}>{v.poznamka}</Col>
                    <Col xs={12} md={6}>
                        <Row>
                            <Col xs={12} sm={4} md={4}>{v.odberatel === null ? "" : subjektFormatter.getUplnaIdentifikace(v.odberatel)}</Col>
                            <Col>VS: {v.vs}</Col>
                            <Col>SS: {v.ss}</Col>
                            <Col>{<Button type="button" onClick={() => this.handleZrusitVyrovnani(v)}>Zrušit vyrovnání</Button>}</Col>
                        </Row>
                    </Col>
                </Row>
            })}
        </CardBlock>;
    }
}

export default connect()(ParovaniPlatebRow);
